module.exports = __webpack_public_path__ + "img/arrow_down_white_32dp@2x.d45fb8c8.png";